import React from 'react';
import { Button, makeStyles, Theme, createStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      color: theme.palette.common.white,
      minWidth: theme.spacing(10),
      marginLeft: theme.spacing(3),
    },
  }),
);

const PrimaryButton: React.FC<any> = (props) => {
  const { children, ...rest } = props;
  const classes = useStyles();
  return (
    <Button
      type='submit'
      variant='contained'
      color='primary'
      className={classes.container}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default PrimaryButton;
